import { useAuthenticator } from "@aws-amplify/ui-react";
import { Spinner } from "@idwal/idwal-react-components";
import { Auth } from "aws-amplify";
import { useEffect } from "react";
import { getRedirectParameter, redirect } from "../services/redirect";

/**
 * Logs out the user and redirects
 * @returns
 */
export const Logout = () => {
    const { user } = useAuthenticator((context) => [context.user]);
    const redirectParam = getRedirectParameter();

    useEffect(() => {
        Auth.signOut().then(() => {
            // Prevent user object being lost on logout
            const userObject = user;
            
            redirect(userObject, redirectParam);
        });
    }, []);

    return <Spinner height={50} width={50} />;
};
